import script from "./UserDaysStats.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDaysStats.vue?vue&type=script&setup=true&lang=js"

import "./UserDaysStats.vue?vue&type=style&index=0&id=b29ffe4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b29ffe4a"]])

export default __exports__